import React, { useState } from 'react';
import gsap from 'gsap';
import { Link } from 'react-router-dom';
import { logo } from '../../assets/Assets';
import { useGlobalContext } from '../../Context';
import './Header.scss';

function Header() {
  const { isNavbarOpen, closeNavbar, setIsNavbarOpen } = useGlobalContext();

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
    isNavbarOpen ? closeAnimation() : animation();
  };

  const lalala = () => {
    alert('hello people');
  };

  const animation = () => {
 gsap.fromTo(
      '.link',
      {
        opacity: 0,
        x: '-40%',
        duration: 1.3,
      },
      {
        opacity: 1,
        stagger: 0.4,
        x: 0,
      }
    );
  };

  const closeAnimation = () => {
    gsap.to('.link', { opacity: 0, x: '-40%', duration: 0.01 });
  };

  return (
    <header className="header">
      <span className="logo">
        <img src={logo} alt="" />
      </span>
      <nav className={`navbar ${isNavbarOpen ? 'show' : ''}`}>
        <Link className="link" to="/" onClick={closeNavbar}>
          Home
        </Link>
        <Link className={`link`} to="/about" onClick={closeNavbar}>
          About
        </Link>
        <Link className="link" to="/contact" onClick={closeNavbar}>
          Contact
        </Link>
      </nav>
      <div className="burger-container" onClick={toggleNavbar}>
        <div className={`hamburger ${isNavbarOpen ? 'show' : ''}`}></div>
      </div>
    </header>
  );
}

export default Header;
